import { defineMessage } from 'services/localization';

export const messages = {
    intro: defineMessage('on_your_phone'),
    appStore: defineMessage('app_store'),
    googlePlay: defineMessage('google_play'),
};
